module.exports = __webpack_public_path__ + "img/Staffelführer.04c250bc.svg";